import { truktApi } from '@api';
import { v1 as uuid } from 'uuid';
import { useMutation } from '@tanstack/react-query';
import { getErrorMessage } from '@trukt/portal-utils/getErrorMessage';
import { useProgressNotifierContext } from '@trukt/ui/ProgressNotifierContext';

import { UseExportReportMutationResult } from './useStartExportReportMutation.types';

export const useStartExportReportMutation = () => {
  const progressNotifierContext = useProgressNotifierContext();

  const mutation: UseExportReportMutationResult = useMutation({
    mutationFn: (request) => truktApi.report.exports.start(request),

    onMutate: () => {
      const progressNotifierId = uuid();
      progressNotifierContext.dispatchNotification({
        id: progressNotifierId,
        label: 'Starting export.',
      });

      return { progressNotifierId };
    },

    onError: (error, _params, context) => {
      if (context?.progressNotifierId) {
        progressNotifierContext.updateNotification(context.progressNotifierId, {
          errorMessage: getErrorMessage(error),
          isError: true,
        });
      }
    },

    onSuccess: (_data, _params, context) => {
      if (context?.progressNotifierId) {
        progressNotifierContext.updateNotification(context.progressNotifierId, {
          isSuccess: true,
          label: 'Report will be emailed shortly',
        });
      }
    },
  });

  return mutation;
};
